import { EMAIL_MESSAGE_STATUSES, PaymentMethods } from '../../../../../../services/exports/Constants';
import TemplateNames from '../email-messages/TemplateNames';

export default {
  page_title: 'Obserwujący',
  fields: {
    name: 'Imię i nazwisko:',
    email: 'E-mail:',
    phone_number: 'Telefon:',
    subscribed: 'Subskrypcja:',
    birthday: 'Urodziny:',
    location: 'Lokalizacja:',
    followed: 'Obserwuje od:',
    lifetime_spent: 'Łączne wydatki:',
    total_orders: 'Łączne zamówienia:',
    google_review: 'Recenzja Google:',
    loyalty_lifetime: 'Program lojaln. łącznie:',
    loyalty_points: 'Program lojaln. dziś:',
  },
  labels: {
    yes: 'Tak',
    no: 'Nie',
    followed_since_date: 'Od {{date}}',
  },
  buttons: {
    edit: 'Edytuj',
    request_data_deletion: 'Żądaj usunięcia danych',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
  },
  tabs: {
    recent_orders: {
      title: 'Ostatnie zamówienia',
      columns: {
        order_id: 'Id',
        items: 'Pozycje',
        total: 'Łączna kwota',
        paid_on: 'Opłacono',
        payment_method: 'Metoda płatności',
      },
      labels: {
        no_orders: 'Brak zamówień',
      },
      payment_methods: {
        [PaymentMethods.CARD]: 'Karta',
        [PaymentMethods.PAYPAL]: 'PayPal',
        [PaymentMethods.APPLE_PAY]: 'Apple Pay',
        [PaymentMethods.GOOGLE_PAY]: 'Google Pay',
        [PaymentMethods.LINK]: 'Link',
        [PaymentMethods.SOFORT]: 'Sofort',
        [PaymentMethods.IDEAL]: 'iDEAL | Wero',
        [PaymentMethods.BANCONTACT]: 'Bancontact',
        [PaymentMethods.EPS]: 'EPS',
        [PaymentMethods.P24]: 'Przelewy24',
        [PaymentMethods.BLIK]: 'BLIK',
        [PaymentMethods.TWINT]: 'TWINT',
        [PaymentMethods.VENMO]: 'Venmo',
        [PaymentMethods.WERO]: 'Wero',
        [PaymentMethods.KLARNA]: 'Klarna',
        [PaymentMethods.TRUSTLY]: 'Trustly',
        [PaymentMethods.PIX]: 'Pix',
        [PaymentMethods.NUPAY]: 'NuPay',
        [PaymentMethods.GIROPAY]: 'Giropay',
        [PaymentMethods.SEPA_DEBIT]: 'Polecenie zapłaty',
        [PaymentMethods.CASH]: 'Gotówka',
        [PaymentMethods.BACS_DEBIT]: 'Polecenie zapłaty',
      },
    },
    messages: {
      title: 'Wiadomości',
      columns: {
        template: 'Szablon',
        status: 'Status',
        opened: 'Otwarto',
        clicked: 'Kliknięto',
        spam_complaint: 'Skarga spamowa',
        unsubscribed: 'Wypisano',
        sent_at: 'Wysłano o',
      },
      labels: {
        yes: 'Tak',
        no: 'Nie',
        not_detected: 'Nie wykryto',
        opened_at: 'Otwarto o {{date}}',
        clicked_at: 'Kliknięto o {{date}}',
        complained_at: 'Zgłoszono o {{date}}',
        unsubscribed_at: 'Wypisano o {{date}}',
        no_messages: 'Brak wiadomości',
      },
      message_statuses: {
        [EMAIL_MESSAGE_STATUSES.SENT]: 'Wysłano',
        [EMAIL_MESSAGE_STATUSES.DELIVERED]: 'Dostarczono',
        [EMAIL_MESSAGE_STATUSES.FAILED]: 'Błąd',
      },
      template_names: {
        ...TemplateNames,
      },
      toasts: {
        failed_to_load_data: 'Nie udało się załadować danych',
      },
    },
    balance_history: {
      title: 'Historia salda',
      columns: {
        created_at: 'Data',
        source: 'Źródło',
        value: 'Punkty',
        points_expire_at: 'Wygasa o',
      },
      labels: {
        source: {
          welcome_bonus: 'Bonus powitalny',
          google_review_reward: 'Nagroda za recenzję Google',
          reward_loyalty_program_conversion: 'Nagroda za konwersję w programie lojalnościowym',
          cashback: 'Cashback',
          refund: 'Zwrot',
          cashback_usage: 'Wykorzystanie cashbacku',
          cashback_usage_refund: 'Zwrot cashbacku',
          expired_points_void: 'Anulowanie wygasłych punktów',
          mobile_app_signup_bonus: 'Bonus za rejestrację w aplikacji',
        },
        no_operations: 'Brak operacji',
      },
    },
  },
};
